import React, { useState } from "react";
import styled from "styled-components";

import Slides from "components/common/layouts/Slides";
import SpectroLogo from "components/common/SpectroLogo";
import BackgroundImage from "gatsby-background-image";
import EnvironmentIcon from "components/atoms/EnvironmentIcon";
import { graphql, useStaticQuery } from "gatsby";
import { getImages } from "utils/images";
import { ShallowButton } from "components/ui/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import RegisterForm from "components/common/RegisterForm";
import SEO from "components/seo";

const EnvWrap = styled(BackgroundImage)`
  min-width: 636px;
  height: 636px;
`;

const NextButton = styled(ShallowButton)`
  align-self: flex-end;
`;

const RegisterContent = styled.div`
  h2 {
    color: #fff;
    font-size: 32px;
  }

  p {
    font-size: 21px;
  }
`;

const Layers = styled(BackgroundImage)`
  align-self: center;
`;

const IndexPage = () => {
  const [slide, setSlide] = useState(0);

  const data = useStaticQuery(graphql`
    query {
      solar: file(relativePath: { eq: "solar.png" }) {
        base
        childImageSharp {
          fixed(width: 636, quality: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      layers: file(relativePath: { eq: "layers.png" }) {
        base
        childImageSharp {
          fixed(width: 525, quality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `);
  const images = getImages(data);

  const slides = [
    <>
      <Slides.Left>
        <SpectroLogo />
        Spectro Cloud provides a Kubernetes multi-cluster management platform
        that is easy to operate at scale while flexible in the infrastructure
        stacks it can provide to developers.
      </Slides.Left>
      <Slides.Right>
        <EnvWrap {...images.getFile("solar")}>
          <EnvironmentIcon primary />
          <EnvironmentIcon index={0} />
          <EnvironmentIcon index={1} />
          <EnvironmentIcon index={2} />
          <EnvironmentIcon index={3} />
          <EnvironmentIcon index={4} />
        </EnvWrap>
        <NextButton size="large" onClick={() => setSlide(1)}>
          Next <FontAwesomeIcon icon={faArrowRight} />
        </NextButton>
      </Slides.Right>
    </>,
    <>
      <Slides.Left>
        <SpectroLogo />
        Spectro Cloud’s superpowers come from our “Cluster Profiles”,
        declarative models of complete infrastructure stacks which enable
        Spectro Cloud’s automated day 2 operations.
      </Slides.Left>
      <Slides.Right>
        <span />
        <Layers {...images.getFile("layers")} />
        <NextButton size="large" onClick={() => setSlide(2)}>
          Next <FontAwesomeIcon icon={faArrowRight} />
        </NextButton>
      </Slides.Right>
    </>,
    <>
      <Slides.Left>
        <SpectroLogo />
        <RegisterContent>
          <h2>Your mission:</h2>
          <p>
            Fulfill a development team’s request for a Kubernetes infrastructure
            stack that supports their new application. You will build a “Cluster
            Profile” that includes the required technologies and versions.
            <br />
            Make sure to be quick - fastest times get rewarded!
          </p>
        </RegisterContent>
      </Slides.Left>
      <Slides.Right>
        <span />
        <RegisterForm />
        <span />
      </Slides.Right>
    </>,
  ];

  return (
    <>
      <SEO title="Spectrocloud Game" />
      <Slides>{slides[slide]}</Slides>
    </>
  );
};

export default IndexPage;
